import { CopyButton, Truncate } from '@newo/ui-kit';

interface SessionIdCellProps {
    edgeLength: number;
    sessionId: string;
}

const SessionIdCell = ({ edgeLength, sessionId }: SessionIdCellProps) => {
    return (
        <div className="flex w-full min-w-0 items-center gap-2">
            <Truncate
                className="min-w-0 flex-1 overflow-hidden"
                endLength={edgeLength}
                mode="middle"
                startLength={edgeLength}
                text={sessionId}
            />
            <CopyButton className="mt-0.5 shrink-0" value={sessionId} />
        </div>
    );
};

export default SessionIdCell;
